// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Card-module--cls1--2ZYmK","cls2":"styles-Card-module--cls2--1GoGu styles-Card-module--cls1--2ZYmK"};